import {SourceCategory} from "../../domain/category"

export interface ICategoryApi {
  getAllCategories(signal?: AbortSignal): Promise<SourceCategory[]>
}

export class CategoryApi implements ICategoryApi {
  constructor(private baseUrl: string) {
  }

  async getAllCategories(signal?: AbortSignal): Promise<SourceCategory[]> {
    const url = this.baseUrl + "/categories"
    const response = await fetch(url, {method: "get", signal, credentials: "include"})
    return await response.json()
  }
}